<template>
  <v-ons-navigator swipeable swipe-target-width="50px"
    :page-stack="pageStack"
    :pop-page="storePop"
    :options="{
      animation: 'fade',
      animationOptions: {duration: 0.2, timing: 'ease-in'}
    }"
    :class="{ 'border-radius': borderRadius }"
  ></v-ons-navigator>
</template>

<script>
//import AppSplitter from './AppSplitter.vue';
import Login from './views/login/Login';
//import DashboardHome from "./views/dashboard/DashboardHome";

export default {
  beforeCreate() {
    this.$store.commit('navigator/push', Login);
  },
  data() {
    return {
      shutUp: this.md
    }
  },
  computed: {
    pageStack() {
      return this.$store.state.navigator.stack;
    },
    options() {
      return this.$store.state.navigator.options;
    },
    borderRadius() {
      return new URL(window.location).searchParams.get('borderradius') !== null;
    }
  },
  methods: {
    storePop() {
      this.$store.commit('navigator/pop');
    },

    /*
    @postpush="showPopTip"
    showPopTip() {
      !this.shutUp && this.$ons.notification.toast({
        message: 'Try swipe-to-pop from left side!',
        buttonLabel: 'Shut up!',
        timeout: 2000
      }).then(i => this.shutUp = i === 0);
    }
    */
  }
};
</script>
